<template>
	<div @scroll="onScroll" class="notification__center">

	    <div class="container3">

	        <div class="title__rank">
	            <span class="helper__tooltip no-icon">
	            	{{translation.page_title}}
	        		<span class="helper__tooltip--text">
	        			{{translation.title_tip}} ;)
	        		</span>
	        	</span>
	        </div>

	        <div class="card-v4">

	        	<div class="filter">
	        		<div>
	        			<form @submit.prevent="search">
	        				<input
	        					type="search"
	        					v-model="searchKeys"
	        					:placeholder="translation.placeholder"
        					>
        					<span
        						class="reset"
        						v-show="searchKeys"
        						@click="resetFilters(true)">x
        					</span>
	        			</form>
						<div class="bug_fix_filter">
							<label for="bug_fix" v-text="translation.show_bug_fixes"></label>
							<p class="switch-description no" v-text="translation.label_wl_no"></p>
							<switch-button id="bug_fix" :checked="showBugFix" :size="'s'" :color="['#e78c8c','#8ce196']" :method="bugFixes" :disabled="!haveItems"/>
							<p class="switch-description" v-text="translation.label_wl_yes">Sim</p>
						</div>
	        			<div class="filter__date">
	        				<span v-text="translation.from"></span>
	        				<input type="date" v-model="dateStart">
	        				<span v-text="translation.to"></span>
	        				<input type="date" v-model="dateEnd"><br>
	        				<button @click="searchDate"></button>
	        			</div>
	        		</div>
	        		<div>
	        			<div>
	        				<label v-text="translation.filter"></label>
	        			</div>
	        			<div class="checkbox__container">
	        				<div>
	        					<div v-for="(c, i) in categories.filter((category) => category.show_front && category.color == '#C7E7FF')" :key="i">
	        						<input
	        							type="radio"
	        							v-model="category"
	        							:id="c.id"
	        							:value="c.value"
										:disabled="!haveItems"
        							>
	        						<label :for="c.id" :style="'color:'+((c.color == '#C7E7FF') ? ('#000') : (c.color))"> {{decodeString(c.title)}} </label>
	        					</div>
	        				</div>
							<div>
								<div v-for="(c, i) in categories.filter((category) => category.show_front && category.color != '#C7E7FF')" :key="i">
	        						<input
	        							type="radio"
	        							v-model="category"
	        							:id="c.id"
	        							:value="c.value"
										:disabled="!haveItems"
        							>
	        						<label :for="c.id" :style="'color:'+((c.color == '#C7E7FF') ? ('#000') : (c.color))"> {{c.title}} </label>
	        					</div>
							</div>
	        			</div>
	        		</div>
	        	</div>

	        	<div class="separator"></div>

	        	<div class="content">

	        		<transition-group name="slide-fade">
		        		<div v-if="(n.category != 'bug_fix') || (n.category == 'bug_fix' && showBugFix)" class="item" v-for="(n, i) in showBugFix ? notificationsBugFixes : notifications" :key="i++">
		        			<div class="category">
		        				<span>{{ translateCategory(n.category)}}</span>
		        			</div>
							<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="icon-right bi bi-caret-right-fill" viewBox="0 0 16 16">
								<path d="m12.14 8.753-5.482 4.796c-.646.566-1.658.106-1.658-.753V3.204a1 1 0 0 1 1.659-.753l5.48 4.796a1 1 0 0 1 0 1.506z"/>
							</svg>
		        			<div class="timeline">
		        				<div>
		        					<span>{{n.createdAt | dayOfMonth(localeLang)}}</span>
		        					<small>{{n.createdAt | shortWeekDay(localeLang)}}</small>
		        				</div>
		        			</div>
		        			<div class="message" :style="setMessageColor(n.category,i)">
								<svg :style="'color: '+(!n.borderRight?'#C7E7FF':n.borderRight)" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="icon-left bi bi-caret-left-fill" viewBox="0 0 16 16">
									<path d="m3.86 8.753 5.482 4.796c.646.566 1.658.106 1.658-.753V3.204a1 1 0 0 0-1.659-.753l-5.48 4.796a1 1 0 0 0 0 1.506z"/>
								</svg>
		        				<div>
		        					<h3 v-text="n.message"></h3>
									<a v-if="n.action" :href="n.action" target="_blank" v-html="n.description"></a>
									<p v-else v-html="n.description"></p>
		        					<label
		        						v-if="n.category == 'sponsoredMessage'"
		        						@click="replySponsoredMessage(n)"
		        						>
		        						{{ translation.label_reply }}
		        						<i class="fa fa-reply" aria-hidden="true"></i>
									</label>
		        				</div>
		        			</div>
		        		</div>
		        	</transition-group>

	        	</div>

	        	<!-- loading -->
	        	<div v-if="loading" class="status loading">
	        		<span></span>
	        	</div>

	        	<!-- no notification -->
	        	<div v-else-if="(notifications.length === 0 && !haveItems) || (notificationsBugFixes.length === 0 && !haveItems && showBugFix)" class="status">
	        		<span>
	        			{{ decodeString(translation.empty) }}
	        		</span>
	        	</div>

	        	<!-- has notification, but not in the current filter -->
	        	<div v-else-if="(notifications.length === 0) || (notificationsBugFixes.length === 0 && showBugFix)" class="status">
	        		<span>
	        			{{ decodeString(translation.not_found) }}
	        			<a @click="resetFilters()" v-text="translation.reset_filters"></a>
	        		</span>
	        	</div>

	        	<!-- end infinite scrool -->
	        	<div v-else-if="endListing && showToTop" class="status">
	        		<span>
	        			{{ decodeString(translation.end) }} :)
	        			<a @click="scrollToTop()" v-text="translation.back_the_top"></a>
	        		</span>
	        	</div>

	        </div>
	    </div>

	    <div
	    	class="scrool__top"
	    	@click="scrollToTop()"
	    	v-show="showToTop">
	    	<i class="fa fa-arrow-up"></i>
	    </div>

    </div>

</template>

<script>
export default {
    name: "notification-center",

    props: {
    	translation: Object,
    	categories: Array,
		fakevalues: Array
    },

    data () {
        return {
        	// data
            notifications 	     : [],
			notificationsBugFixes: [],
			fakevalues2          : [],
            channels		     : '',
            bucket			     : '',

            // filters
            category		: null,
            searchKeys		: null,
            dateStart		: null,
            dateEnd			: null,
			showBugFix      : false,

            // controls
            event			: 'scrool', //scrool | search
            lastId			: null,
            loading 		: true,
            timeoutId		: null,
            showToTop 		: false,
            endListing		: false,
            haveItems 		: false,
            localeLang		: 'en',
        };
    },

    created () {

    	this.localeLang	= this.getLocaleLang(__env.locale);
    	this.channels 	= __env.channels.map(c => `owner=${c}`).join('&');
      	this.bucket     = __env.microservices.bucket.host || 'https://bucket.services.builderall.com';
    	// this.bucket 	= __env.app == 'production'
    	// 				? 'https://bucket.services.builderall.com'
    	// 				: 'https://bucket.office.builderall.io';

		this.fakevalues2 = this.fakevalues;
    	this.getNotifications();
    },

    methods: {

		bugFixes(){
			this.showBugFix = !this.showBugFix;
			if(this.showBugFix)
			{
				if(!this.category)
				{
					this.getBugFixes();
				}
				else
				{
					this.category = null;
				}
			}
		},

		getBugFixes() {
			if(this.showBugFix)
			{
				if(this.haveItems)
				{
					this.loading = true;
					let index = 0;
					for(let i = 0; i < this.notifications.length; i++)
					{
						if(this.notifications[i]['category'] == 'bug_fix')
						{
							this.notificationsBugFixes[index] = this.notifications[i];
							index++;
						}
					}
					this.loading = false;
				}
			}
		},

		setMessageColor(data,key){
			for(let i = 0; i < this.categories.length; i++)
			{
				if(this.categories[i]['value'] == data)
				{
					let style = 'backgroundColor: '+this.categories[i]['color']+';';
					this.notifications[key-1]['borderRight'] = this.categories[i]['color'];
					return style;
				}
			}
		},

    	getNotifications: function () {
			if(this.category == null && this.fakevalues2.length > 0)
			{
				this.notifications = this.fakevalues2;
				this.fakevalues = false;
				this.haveItems = true;
				this.loading = false;
			}
			else
			{
				if(this.category != null)
				{
					this.showBugFix = false;
				}
				var vm 		= this;
				vm.loading 	= true;

				if (vm.event != 'scrool') vm.notifications = [];

				let newAxios = axios.create();
				delete newAxios.defaults.headers.common['X-Requested-With'];

				newAxios
					.get(`${vm.bucket}/notification/filter?${vm.channels}`, {params: vm.getParams()})
						.then(function(resposta) {

							// first response
							if (resposta.data.length > 0) {
								vm.haveItems = true;
							}

							if(vm.showBugFix) {
								vm.getBugFixes();
							}

							// infinite scrool = merge response + current dataset
							if (vm.event == 'scrool') {
								if (resposta.data.length === 0) {
									vm.endListing = true;
								}
								else {
									vm.endListing = resposta.data.length < 25 ? true : false;
									vm.notifications = vm.notifications.concat(resposta.data);
								}
							}

							// request on search = replace current dataset <= response
							else {
								vm.endListing = resposta.data.length < 25 ? true : false;
								vm.notifications = resposta.data
							}

							console.log (
								'notifications: '	 	+vm.notifications.length,
								'\ncurrent request: '	+resposta.data.length,
								'\nendListing: '		+vm.endListing,
								'\nhave items: '		+vm.haveItems
							)
						})
						.catch(function(error) {
							toastr.error(error);
						})
						.finally(function(){
							vm.loading = false;
						})
			}
    	},

    	// called on handle infinite scrool
    	loadMoreNotifications () {
    		if (!this.loading && !this.endListing) {
    			this.lastId = this.notifications[this.notifications.length - 1]._id;
    			this.getNotifications();
    		}
    	},

    	// handle search
    	search () {
    		this.lastId = null;
    		this.event 	= 'search';
    		this.getNotifications();
    	},

    	// handle search by date
    	searchDate () {

    		if (!this.dateStart && !this.dateEnd)
    			this.search()
    		else if (!this.dateStart || !this.dateEnd)
    			toastr.warning(this.translation.error_date);
    		else
    			this.search();
    	},

    	// return params object to make request. NULL are ignored by axios
    	getParams () {
    		let start_at 	= null;
    		let end_at 		= null;

    		// date validation
    		if (this.dateStart && this.dateEnd) {
    			try {
    				start_at 	= new Date(this.dateStart).toISOString();
    				end_at		= new Date(this.dateEnd).toISOString()
    			} catch (e) {
    				toastr.error('Date Error');
    				console.error(e)
    			}
    		}

    		return {
    			category	: this.category,
    			search 		: this.searchKeys,
    			start_at 	: start_at,
    			end_at  	: end_at,
    			after 		: this.lastId
    		};
    	},

    	// no comments :)
    	resetFilters (onlyText = false) {

           	if (!onlyText) {
   				this.category 	= null;
   		        this.dateStart 	= null;
   		       	this.dateEnd 	= null;
           	}

			this.showBugFix = false;
           	this.searchKeys = null;
           	this.event 		= 'search';
           	this.getNotifications();
    	},

    	// infinite scrool handler
    	onScroll ({ target: { scrollTop, clientHeight, scrollHeight }}) {
	      	if (scrollTop + clientHeight >= scrollHeight) {
	      		this.event = 'scrool';
	      		this.loadMoreNotifications();
	      	}
	      	this.showToTop = scrollTop > clientHeight;
	    },

	    // a sample toTop button
	    scrollToTop () {
	    	document.querySelector('.notification__center').scrollTo(0,0);
	    },

	    // parse category slug in text listing
	    translateCategory (slug) {
	    	let index = this.categories.findIndex((category) => category.value == slug && slug && slug != '');
	    	return index > -1 ? this.categories[index].title : this.translation.others;
	    },

	    // bind modal values to reply customer sponsor message
	    replySponsoredMessage (notification) {
	    	$('#send-message-upline-sponsored-answer').modal('show')
	    	document.getElementById('js-input-answer-sponsored-to').value = notification.message;
	    	document.getElementById('js-p-answer-sponsored').innerHTML = notification.description;
	    },

	    // parse office lang in moment format
	    getLocaleLang (l) {
			  return { 'us': 'en', 'br': 'pt' }[l] || l
		  },

      decodeString(string) {
        return new DOMParser().parseFromString(string, 'text/html').querySelector('body').textContent;
      },
    },

    filters: {

    	// localeLang is passed by param because this cannot be read here
    	dayOfMonth (day, localeLang) {
    		return moment(day).locale(localeLang).format('DD');
		},

		shortWeekDay (day, localeLang) {
			return moment(day).locale(localeLang).format('MMM');
		}

    },

    watch: {

    	// prevent empty string on query string
    	searchKeys () {
    		this.searchKeys = this.searchKeys == '' ? null : this.searchKeys;
    	},

    	// when assing category to null, the watcher is called again. This prevent repetition of requests
    	category () {
    		if (this.category == 'null') {
    			this.category = null;
    			return;
    		}
    		this.search();
    	}
    }
};
</script>

<style scoped lang="scss">

.notification__center {
	overflow: auto;
	height: calc(100vh - 135px);
	padding-right: 5px;

	.helper__tooltip--text {
		left: 0;
		top: 2rem;
	}

	.scrool__top {
		position: fixed;
	    bottom: 33px;
	    background: rgb(48, 145, 242);
	    width: 48px;
	    height: 48px;
	    border-radius: 50%;
	    display: flex;
	    align-items: center;
	    justify-content: center;
	    box-shadow: 0 5px 36px rgba(0,0,0,.18);
	    cursor: pointer;
	    left: 25px;
    	z-index: 1;
		.fa {
			color: #fff;
		}
	}

	.card-v4 {

		.filter {
			display: grid;
			grid-template-columns: auto 1fr;
			gap: 2rem;
			padding-bottom: 1rem;

			> div:first-child {
				display: flex;
			    flex-direction: column;
			    justify-content: space-around;
			    min-height: 90px;
			}
			.bug_fix_filter{
				display: flex;
				justify-content: center;
				flex-direction: row;
				gap: 1%;
				align-items: center;
				.no{
					margin-left: 1em !important;
				}
				label{
					margin: 0;
				}
				.switch-description{
					margin: 0;
					font-size: .7em;
				}
			}
			div {
				form {
					position: relative;
					display: flex;
					align-items: center;
					span.reset {
						position: absolute;
					    right: 15px;
					    height: 15px;
					    width: 15px;
					    background: #c6c2c2;
					    border-radius: 50%;
					    text-align: center;
					    line-height: 0;
					    font-weight: bolder;
					    font-size: 11px;
					    padding-top: 7px;
					    color: #fff;
					    transition: .4s;
					    cursor: pointer;
					    &:hover {
					    	background: black;
					    }
					}
				}
				input[type="search"] {
					background: #f3f3f3;
				    border: unset;
				    border-radius: 8px;
				    background-image: url("data:image/svg+xml,%0A%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z' fill='black'/%3E%3C/svg%3E%0A");
				    background-repeat: no-repeat;
				    background-position: 15px center;
				    padding-left: 48px;
				    height: 40px;
				    width: 100%;
				    min-width: 300px;
				    font-size: 0.9rem;
				}

				&.checkbox__container > div {
					display: grid;
					grid-template-columns: repeat(auto-fill,minmax(200px,1fr));

					label {
						font-weight: normal;
						cursor: pointer;
						font-size: .95rem;
					}
				}

				&.filter__date {
					display: grid;
					grid-auto-flow: column;
					align-items: end;
					gap: 5px;
					margin: 0.5rem 1rem 0 1rem;
					justify-content: space-evenly;

					input[type="date"] {
					    border: unset;
					    border-bottom: 1px solid #ddd;
					    line-height: 1rem;
					    height: 24px;
					    font-size: .9rem;
					    width: 140px;

					    @media only screen and (max-width: 1200px) {
							grid-column: 2;
						}
					}

					span, button {
						margin-bottom: 6px;
					}

					button {
						background: url("data:image/svg+xml,%0A%3Csvg width='18' height='18' viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M12.5 11H11.71L11.43 10.73C12.41 9.59 13 8.11 13 6.5C13 2.91 10.09 0 6.5 0C2.91 0 0 2.91 0 6.5C0 10.09 2.91 13 6.5 13C8.11 13 9.59 12.41 10.73 11.43L11 11.71V12.5L16 17.49L17.49 16L12.5 11ZM6.5 11C4.01 11 2 8.99 2 6.5C2 4.01 4.01 2 6.5 2C8.99 2 11 4.01 11 6.5C11 8.99 8.99 11 6.5 11Z' fill='black'/%3E%3C/svg%3E%0A") transparent no-repeat center;
						background-size: 14px;
						width: 14px;
						height: 14px;
						border: none;
						cursor: pointer;
					}
				}
			}
		}

		.separator {
			height: 10px;
			background: #f8fafd;
			margin: 0 -2rem;
			border-bottom: 1px solid #c6c6c6;
		}

		.content {

			.item {
				display: grid;
			    grid-template-columns: 100px 15px 100px 1fr;
			    align-items: center;
			    gap: 1rem;

				.icon-right{
					color: #2f80fc;
				}

			    .timeline {
			    	position: relative;
			    	height: 100%;
			    	display: flex;
			    	justify-content: center;
			    	align-items: center;

			    	> div {
			    		width: 60px;
			    		height: 60px;
			    		background: var(--theme-color-primary);
			    		border-radius: 50%;
			    		color: #fff;
			    		display: flex;
			    		flex-direction: column;
			    		justify-content: center;
			    		text-align: center;
			    		z-index: 1;
			    		font-weight: bold;
			    		text-transform: uppercase;

			    		span {
			    			font-size: 26px;
			    		}
			    	}

			    	&:after {
			    		content: close-quote;
			    		position: absolute;
			    		width: 2px;
			    		height: 100%;
			    		background: var(--theme-color-primary);
			    		top: 0;
			    		z-index: 0;
			    	}
			    }

			    &:first-child .message {
			    	margin-top: 1rem;
			    }

			    .message {
		    	    background-color: #C7E7FF;
		    	    border: unset;
		    	    padding: 10px 20px;
		    	    position: relative;
		    	    border-radius: 8px;
		    	    margin: .5rem 0 .5rem 0;
					&:hover{
						transition: .15s;
						transform: scale(1.01);
					}

					.icon-left{
						position: absolute;
						margin-left: -3.8%;
						margin-top: 2.7%;
					}

		    	    h3 {
		    	    	font-weight: normal;
		    	    	color: var(--theme-color-accent);
		    	    	word-break: break-all;
		    	    }
		    	    p,a {
						font-size: .95rem;
					    line-height: 1.3rem;
						color: inherit;
		    	    }
		    	    label {
		    	    	font-size: inherit;
		    	    	float: right;
		    	    	font-weight: normal;
		    	    	cursor: pointer;
		    	    }

		    	}
			}
		}
		.status {
			position: relative;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    padding-top: 1rem;
		    line-height: 1.5;
   			text-align: center;

		    &.loading > span {
		    	background: url(/internacional/public/office4/img/franchise/button-loader.gif) #fff no-repeat;
		    	background-size: 110px auto;
		    	background-position: center;
		    	color: transparent !important;
		    	width: 150px;
    			filter: grayscale(1);
		    }

			span {
				z-index: 1;
				background: #fff;
				padding: 1rem;
				color: #999;
				font-size: 0.9rem;
				text-transform: uppercase;
			}
			&:after {
				content: close-quote;
			    position: absolute;
			    width: 100%;
			    border: 1px solid gainsboro;
			    z-index: 0;
			}
			a {
				font-size: inherit;
			}
		}
	}
}


@media only screen and (max-width: 768px) {
    .card-v4 {
    	.filter {
    		grid-template-columns: unset !important;
    		input[type="search"] {
    			min-width: unset !important;
    		}
    	}
    	.content .item {
    		grid-template-columns: 1fr 5fr !important;
    	}
    }
	.category,
	.icon-right,
	.icon-left{
		display: none;
	}
}

 @media only screen and (max-width: 1200px) {
	.card-v4 .filter > div:first-child {
		min-height: 115px !important;
	}
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/notification/index.vue